var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',[_c('b-card-body',[_c('UsersLogTable',{attrs:{"fields":_vm.fields,"items":_vm.items,"status":_vm.status,"total-rows":_vm.perPage},on:{"reset":_vm.reset,"onPerPage":_vm.onPerPage}}),_vm._v(" "+_vm._s(_vm.perPage)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }